// src/api/proof.js
import { resolveBase } from "./config";

export async function pack({ query, docs, budget = 300 }) {
  const base = resolveBase("proof");
  if (!base) {
    throw new Error("No PROOF API configured");
  }

  // Normalize docs to array of {id, text} for server
  let normDocs = [];
  if (Array.isArray(docs)) {
    normDocs = docs.map((d, i) =>
      typeof d === "string"
        ? { id: String(i + 1), text: d }
        : { id: d.id || String(i + 1), text: d.text || "" }
    );
  } else if (typeof docs === "string") {
    normDocs = docs
      .split(/\n\s*\n/g)
      .map((chunk, i) => ({ id: String(i + 1), text: chunk.trim() }))
      .filter((d) => d.text);
  }

  const res = await fetch(`${base}/pack`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ query, docs: normDocs, budget }),
  });

  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(
      `PROOF API pack failed ${res.status}${text ? `: ${text}` : ""}`
    );
  }

  return res.json();
}
